import { get, post } from '../tools/http';
import { send } from '../tools/ws_chat.js';
import { getImgUrl } from '../tools/uploader';
import placeHolder from '../assets/images/account/placeHolder-m.png';

export default {
    state: {
        room_list_data: [],
        room_messages_data: [],
        currentRoom: {},
        currentRoomChanger: true,
        avatarStub: placeHolder,
    },
    mutations: {
        // socket mutation
        writeRoomList: (state, data) => {
            state.room_list_data = data.sort((a, b) => {
                return b.last_message_time - a.last_message_time;
            });
        },
        addRoom: (state, data) => {
            state.room_list_data.push(data);
        },
        writeRoomMessages: (state, data) => {
            if (data.messages) {
                state.room_messages_data = data.messages;
            } else {
                state.room_messages_data = [];
            }
        },
        addRoomMessage: (state, data) => {
            const updateIndex = state.room_list_data.findIndex((item) => {
                if (item.id == data.room_id) {
                    return true;
                }
            });
            if (updateIndex < 0) return;

            state.room_list_data[updateIndex].last_message_time =
                parseInt(data.create_date);
            if (state.currentRoom.id == data.room_id) {
                state.room_messages_data.push(
                    {
                        'author': data.author_id,
                        'type': data.message_type,
                        'payload': data.message_payload,
                        'date': data.create_date,
                    },
                );
            } else {
                state.room_list_data[updateIndex].new_messages += 1;
            }
            state.room_list_data = state.room_list_data.sort((a, b) => {
                return b.last_message_time - a.last_message_time;
            });
        },

        updateReadRoomsCounter: (state, data) => {
            const updateIndex = state.room_list_data.findIndex((item) => {
                if (item.id == data.room_id) {
                    return true;
                }
            });
            if (updateIndex >= 0) {
                state.room_list_data[updateIndex].new_messages = 0;
                state.room_list_data = state.room_list_data.sort((a, b) => {
                    return b.last_message_time - a.last_message_time;
                });
            }
        },

        //other mutation
        writeCurrentRoom: (state, data) => {
            if (state.currentRoom.id != data.id &&
                data.id != 'Chat-is-destroy-now') {
                state.currentRoom = data;
                state.currentRoomChanger = !state.currentRoomChanger;
                send('get_room_messages', { room_id: state.currentRoom.id });
            }
        },
    },
    actions: {
        // users: Arr, id: String,
        // new_messages: number, last_message_time: number
        roomListCreator: async (ctx, roomlist) => {
            let blkParams = '';
            let ids = [];
            for (let index = 0; index < roomlist.length; index++) {
                let usersInRoomLocalData = roomlist[index].users.slice();
                let params = '';
                let blkPrefix = '';
                const cUserIndex = usersInRoomLocalData.findIndex((itm)=>{
                    return itm.user_id == ctx.rootGetters.user.id;
                });
                usersInRoomLocalData.splice(cUserIndex, 1);
                usersInRoomLocalData.map((user, uindex) => {
                    let param;
                    let prefix = '';
                    if (uindex != usersInRoomLocalData.length - 1) prefix = '&';
                    param = 'users[]=' + user.user_id + prefix;
                    params += param;
                    ids.push(user.user_id);
                });
                if (index != roomlist.length - 1) blkPrefix = '&';
                blkParams += params + blkPrefix;
            }

            if (blkParams == '') return;

            let userAuthInfo = null;
            try {
                userAuthInfo = await get('auth',
                    'api/v1/users/search-by-id?' + blkParams);
            } catch (e) {
                userAuthInfo = [];
            }
            let usersProfileInfo = null;
            try {
                usersProfileInfo = await post('profile',
                    'user/info/list', {users: ids}, true);
            } catch (e) {
                usersProfileInfo = { users: [] };
            }

            let users = [];
            for( let i=0; i < userAuthInfo.length; i++ ) {
                const userAuthInProfile =
                    usersProfileInfo.users.find((userProfile) => {
                        return userAuthInfo[i].user_id == userProfile.userId;
                    });
                const avatarUrl = userAuthInProfile && userAuthInProfile.avatar &&
                userAuthInProfile.avatar.url ?
                    userAuthInProfile.avatar.url : '';
                const loadedavatar = await getImgUrl(avatarUrl,
                    ctx.rootGetters.user_img_stub);

                users.push({
                    name: userAuthInfo[i].user_name ?
                        userAuthInfo[i].user_name : '',
                    surname: userAuthInfo[i].surname ?
                        userAuthInfo[i].surname : '',
                    id: userAuthInfo[i].user_id,
                    avatar: loadedavatar,
                });
            }
            let newRoomList = [];
            for (let ri = 0; ri < roomlist.length; ri++) {
                newRoomList.push({
                    id: roomlist[ri].id,
                    users: [],
                    new_messages: roomlist[ri].new_messages,
                    last_message_time: roomlist[ri].last_message_time,
                });
                for (let ui = 0; ui < roomlist[ri].users.length; ui++) {
                    let uid = roomlist[ri].users[ui].user_id;
                    if (uid == ctx.rootGetters.user.id) continue;
                    const userdef = users.find((itm)=>{
                        return itm.id == uid;
                    });
                    newRoomList[ri].users.push(userdef);
                }
            }
            return newRoomList;
        },

        //socket callBacks
        room_created: async (ctx, data) => {
            const roomList = await ctx.dispatch('roomListCreator', [{
                id: data.room_id,
                users: data.users.map((u) => {
                    return {
                        user_id: u,
                    };
                }),
                new_messages: data.new_messages,
                last_message_time: data.last_message_time,
            }]);
            ctx.commit('addRoom', roomList[0]);

            if (data.ownerId === ctx.rootGetters.user.id) {
                ctx.commit('writeCurrentRoom', roomList[0]);
            }
        },
        user_added_to_group: (ctx, data) => {},
        room_users: (ctx, data) => {},
        room_messages: (ctx, data) => {
            ctx.commit('writeRoomMessages', data.data);
            if (data.data.messages) {
                const messages_id_arr = data.data.messages.map((item) => {
                    return item.id;
                });
                const payload = {
                    room_id: data.data.room_id,
                    messages_id: messages_id_arr,
                };
                send('message_has_read', payload);
            }
        },
        message_has_read: async (ctx, data) => {
            if (data.user_id != ctx.rootGetters.user.id) return;
            ctx.commit('updateReadRoomsCounter', data);
        },

        room_list: async (ctx, data) => {
            const roomList =
                await ctx.dispatch('roomListCreator', data.user_rooms);
            if (!roomList) return;
            ctx.commit('writeRoomList', roomList);
        },

        new_message: (ctx, data) => {
            ctx.commit('addRoomMessage', data);
        },

        room_existed: async (ctx, data) => {
            const room = ctx.state.room_list_data.find((rm)=>{
                return rm.id == data.room_id;
            });
            ctx.commit('writeCurrentRoom', room);
        },

        // other actions
        set_current_room: (ctx, data) => {
            ctx.commit('writeCurrentRoom', data);
        },
    },
    getters: {
        room_list_data: state => state.room_list_data,
        current_room: state => state.currentRoom,
        room_messages_data: state => state.room_messages_data,
        user_img_stub: state => state.avatarStub,
        currentRoomChanger: state => state.currentRoomChanger,
        getUnreadMessage: (state) => {
            if (state.room_list_data.length == 0) return null;
            return state.room_list_data.reduce((sum, current) => {
                return sum + current.new_messages;
            }, 0);
        },
    },
};
